/** Fetch learning tutorial creation options (themes, layouts, TTS, languages). */

export async function fetchLearningTutorialOptions(api) {
  const { data } = await api.get('/learning-tutorials/options');
  return data;
}

export const EMPTY_OPTIONS = {
  artifact_groups: [],
  artifact_strategies: [],
  themes: [],
  layout_modes: [],
  languages: [],
  tts_providers: [],
  edge_voice_styles: [],
  elevenlabs_voices: [],
  murf_voices: [],
  murf_locales: [],
  murf_falcon_voices: [],
  murf_models: [],
  murf_default_model: 'GEN2',
  visual_providers: [],
  defaults: {},
};
